import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';

// Dummy data
const data = [
  { name: 'Plumbing', value: 12 },
  { name: 'Electrical', value: 8 },
  { name: 'Laundry', value: 5 },
  { name: 'General', value: 10 },
  { name: 'Other', value: 3 },
];
let totalRepairs=3;
const COLORS = ['#4caf50', '#2196f3', '#ff9800', '#9c27b0', '#f44336'];
const renderLabel = ({ name, value }) => {
    return value > 0 ? `${name}: ${value}` : '';
  };
const RepairsPieChart = ({data, totalRepairs}) => {
  console.log(data)
  return (
    <Box sx={{ p: 3, background: '#fff', borderRadius: 2, boxShadow: 1 }}>
      <Typography variant="h6" fontWeight="bold">
        Repairs by Category
      </Typography>
      <Typography variant="h4">
        <NumericFormat value={totalRepairs} thousandSeparator displayType="text"/>
      </Typography> 
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={60}
            outerRadius={100}
            fill="#8884d8"
            label
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default RepairsPieChart;
